import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

export default function AIModal({

  modal,
  toggleModal,
  sub,
  setSubmit,
  Email_modal_msg,
  receivers = [],
  setReceivers,
  ccEmails = [], setCcEmails, handleSubmit,email_loader
}) { 
  return (
    <>
      <Modal isOpen={modal} toggle={toggleModal} centered>
        <>
          <ModalHeader toggle={toggleModal}>
            Send Email{" "}
            <p className="f-light mb-0" style={{ fontSize: "10px" }}>
              {Email_modal_msg}
            </p>
          </ModalHeader>


          {sub ? <div className="d-flex align-items-center justify-content-center p-5">
            <div className="d-flex justify-content-center">

              <img src="https://i.gifer.com/7efs.gif" width={100} />
            </div>
          </div> : <>
            <ModalBody className="mx-2 my-0">
              <label>Email Address:</label>
              <Typeahead
                id="receiver-typeahead"
                multiple
                options={[]}
                onChange={(selected) => setReceivers(
                  selected.map(item => (typeof item === "string" ? item : item.label))
                )}

                selected={receivers}
                placeholder="Enter recipient emails"
                allowNew // Allow entering new emails not in the list
                newSelectionPrefix="Add a new email: "
                isInvalid={
                  receivers.some(
                    (email) => !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
                  )
                }
                renderMenuItemChildren={(option) => <span>{option}</span>}
              />

              <label className="mt-3">CC:</label>
              <Typeahead
                id="cc-typeahead"
                multiple
                onChange={(selected) => setCcEmails(
                  selected.map(item => (typeof item === "string" ? item : item.label))
                )}
                selected={ccEmails}
                placeholder="Enter CC emails"
                allowNew
                options={[]}
                newSelectionPrefix="Add a new email: "
                isInvalid={
                  ccEmails.some(
                    (email) => !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
                  )
                }
                renderMenuItemChildren={(option) => <span>{option}</span>}
              />
            </ModalBody>
            <ModalFooter>
              <button
                disabled={email_loader == false && receivers?.length > 0 ? false : true}
                color="primary"
                onClick={() => {
                  // Here you can call your API and pass receivers and ccEmails
                  // setSubmit(!sub);
                  handleSubmit()
                }}
                className="btn btn-outline-primary"
              >
                {email_loader ? <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                ></div> : "Send"}
              </button>{" "}
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
            </ModalFooter>
          </>}
        </>
      </Modal>
    </>
  );
}
